/**
 * URLs de la configuración de vistas del usuario.
 *
 * **El PUT y el DELETE NO comparten la forma de la URL, y no es un descuido de este archivo: es lo
 * que el backend expone.** Las dos rutas están declaradas a mano en `UsuarioVistaModulosController`,
 * una al lado de la otra, y son distintas:
 *
 *     [HttpPut("v1/UsuarioVistaModulo/{id}")]        // singular, clave como segmento
 *     [HttpDelete("v1/UsuarioVistaModulos({id})")]   // plural, clave entre paréntesis
 *
 * El GET y el POST no llevan ruta explícita, así que los resuelve el enrutamiento OData por el
 * entity set —`EntitySet Name="UsuarioVistaModulos"`, plural—.
 *
 * Esto ya se «arregló» una vez en la dirección equivocada. Al ver que tres de las cuatro URLs usaban
 * el plural y que el metadata declara el entity set así, se unificó el PUT a
 * `/UsuarioVistaModulos({id})` dando por hecho que el singular era un typo — sin mirar la tabla de
 * rutas del backend. Un `[HttpPut]` con ruta explícita gana sobre la convención de OData, así que
 * después del cambio el PUT dejó de tener ruta: guardar la configuración de columnas del detalle y
 * guardar una vista desde ConfigOptions quedaron los dos rotos.
 *
 * Mientras el backend no unifique las dos rutas —y unificarlas exige desplegar los dos lados a la
 * vez—, acá hay que reflejar la asimetría tal como es. Por eso son dos funciones con nombre propio y
 * no una sola: que no se pueda usar la del DELETE para el PUT por descuido.
 */

/** Entity set tal como lo declara el metadata OData. Para el GET (con query options) y el POST. */
export const urlUsuarioVistaModulos = (): string => '/UsuarioVistaModulos'

/**
 * PUT. Singular y con la clave como segmento de ruta, que es la ruta que sirve el backend
 * (`[HttpPut("v1/UsuarioVistaModulo/{id}")]`). No tocar sin cambiar el atributo del controlador.
 */
export const urlUsuarioVistaModuloParaActualizar = (id?: number): string => `/UsuarioVistaModulo/${id}`

/**
 * DELETE. Plural y con la clave entre paréntesis
 * (`[HttpDelete("v1/UsuarioVistaModulos({id})")]`).
 */
export const urlUsuarioVistaModuloParaEliminar = (id: number): string => `/UsuarioVistaModulos(${id})`
